import { render, staticRenderFns } from "./BadgeColumnRenderer.vue?vue&type=template&id=625b2412&"
import script from "./BadgeColumnRenderer.vue?vue&type=script&lang=ts&"
export * from "./BadgeColumnRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports